var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_container"},[_c('el-scrollbar',[_c('div',{staticClass:"container"},[_vm._v(" 更新中…… ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }